import { makeStyles } from "@material-ui/core";
import React from "react";
import { tesaGreyDisabled, tesaGrey6 } from "../../styles/colors";

type Specifications = TestRequestRaw.Schemas.SpecificationDTO;
type SampleTypeName = "Substrate" | "Product" | "Specification" | "TestProgram";

interface SampleSuggestionFieldProps {
  label?: string;
  sampleTypeName: SampleTypeName;
  value: string | Specifications[] | null;
}

const useStyles = makeStyles({
  container: {
    backgroundColor: tesaGrey6,
    padding: "6px 14px",
  },
  content: {
    // limited to 6 lines of text + label
    maxHeight: "6.5rem",
    overflowY: "auto",
    whiteSpace: "pre-line",
  },
  label: {
    color: tesaGreyDisabled,
    fontSize: "0.85rem",
  },
});

const SampleSuggestionField: React.FC<SampleSuggestionFieldProps> = (props) => {
  const classes = useStyles(props);
  const { label, sampleTypeName, value } = props;
  const finalLabel = label || `${sampleTypeName}(s) suggested by the requester`;
  let finalValue = value?.toString().match(/\S/g) ? value?.toString() : "Not defined by requester";
  // iterate through specifications to build concatenated testPlanVersionName string for display
  if (sampleTypeName === "Specification" && value instanceof Array) {
    const specificationStrings: string[] = [];
    value?.map((specification) => specificationStrings.push(specification.testPlanVersionName));
    finalValue = specificationStrings.length ? specificationStrings.join(", ") : finalValue;
  }

  return (
    <div className={classes.container}>
      <div className={classes.label}>{finalLabel}</div>
      <div className={classes.content}>{finalValue}</div>
    </div>
  );
};

export default SampleSuggestionField;
